import { useEffect, useMemo, useState } from "react";
import {
  createGlobalStyle,
  css,
  DefaultTheme,
  ThemeProvider as StyledComponentsThemeProvider,
} from "styled-components";
import { colors } from "./ThemeColor";

export function theme(darkMode: boolean): DefaultTheme {
  return {
    ...colors(darkMode),

    // css snippets
    textEllipse: css`
      text-overflow: ellipsis;
      white-space: nowrap;
      overflow: hidden;
    `,
    // set font
    // fontFamily: css`
    //   font-family: "Tahoma";
    // `,
  };
}

export default function ThemeProvider({
  children,
}: {
  children: React.ReactNode;
}) {
  //   const darkMode = useIsDarkMode();
  const darkMode = false;

  const themeObject = useMemo(() => theme(darkMode), [darkMode]);

  return (
    <StyledComponentsThemeProvider theme={themeObject}>
      {children}
    </StyledComponentsThemeProvider>
  );
}

export const ThemedGlobalStyle = createGlobalStyle`
html {
  font-size: 16px;
}

body {
  background-color: #FDF8EC;
  color: #3A2E22;
}

a {
 cursor: pointer;
}

a:hover{
  color: inherit;
}

@media screen and (min-width:321px) and (max-width:375px){html{font-size:42.66px}}
@media screen and (min-width:376px) and (max-width:768px){html{font-size:50px}}
`;

export const SCREEN_XXL = 1400 + "px";
export const SCREEN_XL = 1200 + "px";
export const SCREEN_MD = 992 + "px";
export const SCREEN_SM = 768 + "px";
export const SCREEN_XS = 576 + "px";
export const SCREEN_XXS = 320 + "px";
